module.exports = __webpack_public_path__ + "static/img/food-item.84a9af5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/food-item.png
// module id = 2
// module chunks = 0